import { useEffect, useRef } from 'react';
import api from '../services/api';

export const useSession = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Verificar token cada 5 minutos
    const checkToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        // Intentar renovar el token si es necesario
        await api.refreshToken();
      } catch (error) {
        console.error('Error verificando sesión:', error);
        // Si hay error, limpiar sesión
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    };

    // Verificar inmediatamente al montar
    checkToken();

    // Configurar verificación periódica
    intervalRef.current = setInterval(checkToken, 5 * 60 * 1000); // 5 minutos

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return null;
}; 